import { Skeleton } from '@/components/ui';
import React from 'react';

export default function DateSelectionSkeleton() {
  return (
    <div className='flex w-full max-w-2xl flex-col items-center justify-center gap-4 border rounded-2xl bg-white p-4'>
      <div className='w-full flex flex-col gap-4'>
        <div className='flex w-full items-center justify-between gap-4'>
          <Skeleton className='h-8 w-8 rounded-lg' />
          <div className='flex gap-2'>
            <Skeleton className='h-8 w-24 rounded-lg' />
            <Skeleton className='h-8 w-24 rounded-lg' />
          </div>
          <Skeleton className='h-8 w-8 rounded-lg' />
        </div>
        <Skeleton className='w-full h-64 rounded-lg' />
      </div>
    </div>
  );
}
